import { Link } from '@tanstack/react-router'
import { Card } from '../../components/ui/card'
import { PublicFrame } from '../components/public-layout'
import { useI18n } from '../lib/i18n'

/** Any other address of the back office's host: neutral, the same signed in or not. */
export function NotFound() {
  const { t } = useI18n()
  return (
    <PublicFrame>
      <Card>
        <h1 className="text-2xl">{t('common.notFound.title')}</h1>
        <p className="mt-3 text-ink-muted">{t('common.notFound.body')}</p>
        <Link
          to="/"
          className="mt-6 inline-flex rounded-lg bg-primary px-5 py-2.5 text-sm font-medium text-primary-contrast hover:bg-primary-hover"
        >
          {t('common.notFound.action')}
        </Link>
      </Card>
    </PublicFrame>
  )
}
